// PAGES
import { createRouter, createWebHistory } from 'vue-router'

import Home from '../views/Home/Home.vue'
import BecomeSeller from '../views/BecomeSeller/BecomeSeller.vue'

import NotFound from '../views/NotFound/NotFound.vue'


// ACCOUNT
import TokenAuth from '../views/Account/TokenAuth.vue'


// MERCHANT
import Dashboard from '../views/Merchant/Dashboard/Dashboard.vue'
import Sales from '../views/Merchant/Sales/Sales.vue'
import SalesDetails from '../views/Merchant/Sales/SalesDetails.vue'
import Returns from '../views/Merchant/Returns/Returns.vue'
import Products from '../views/Merchant/Products/Products.vue'
import ProductsAdd from '../views/Merchant/Products/ProductsManager.vue'
import ProductsManager from '../views/Merchant/Products/ProductsManager.vue'
import Campaigns from '../views/Merchant/Campaigns/Campaigns.vue'
import Store from '../views/Merchant/Store/Store.vue'
import Company from '../views/Merchant/Company/Company.vue'
import CompanyRedirectAdd from '../views/Merchant/Company/CompanyRedirectAdd.vue'


const routes = [
  { path: '/', name: 'redirect', redirect: '/en/', component: Home, meta: {title:'DNE Market'} },
  { path: '/:lang/', name: 'Home', component: Home, meta: {title:'DNE Market'} },

  { path: '/:lang/become-seller', name: 'BecomeSeller', component: BecomeSeller },
  
  { path: '/:lang/:catchAll(.*)', component: NotFound, meta: {title:'DNE Market'} },
  
  
  // ACCOUNT
  { path: '/:lang/account/token-auth/', name: 'TokenAuth', component: TokenAuth },
  
  
  // MERCHANT
  { path: '/:lang/merchant/dashboard', name: 'Dashboard', component: Dashboard, meta: {title:'Dashboard | DNE Market'} },
  
  { path: '/:lang/merchant/sales', name: 'Sales', component: Sales, meta: {title:'DNE Market'} },
  { path: '/:lang/merchant/sales/:orderId', name: 'SalesDetails', component: SalesDetails, meta: {title:'DNE Market'} },
  
  { path: '/:lang/merchant/returns', name: 'Returns', component: Returns, meta: {title:'DNE Market'} },

  { path: '/:lang/merchant/products', name: 'Products', component: Products, meta: {title:'DNE Market'} },
  { path: '/:lang/merchant/products/add', name: 'ProductsAdd', component: ProductsAdd, meta: {title:'DNE Market'} },
  { path: '/:lang/merchant/products/manager/:productID', name: 'ProductsManager', component: ProductsManager, meta: {title:'DNE Market'} },
  
  { path: '/:lang/merchant/campaigns', name: 'Campaigns', component: Campaigns, meta: {title:'DNE Market'} },
  { path: '/:lang/merchant/store', name: 'Store', component: Store, meta: {title:'DNE Market'} },
  { path: '/:lang/merchant/company/:companyReference', name: 'Company', component: Company, meta: {title:'DNE Market'} },
  { path: '/:lang/add-store-redirect', name: 'CompanyRedirectAdd', component: CompanyRedirectAdd, meta: {title:'DNE Market'} },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // Get the page title from the route meta data that we have defined
  // See further down below for how we setup this data
  const title = to.meta.title

  //Take the title from the parameters
  const titleFromParams = to.params.pageTitle;
  // If the route has a title, set it as the page title of the document/page
  if (title) {
    document.title = title
  }
  // If we have a title from the params, extend the title with the title
  // from our params
  if (titleFromParams) {
    document.title = `${titleFromParams} - ${document.title}`;
  }
  // Continue resolving the route
  next()
})


export default router
